export default __webpack_public_path__ + "static/media/Setting_PhantasiaUS.2352e797.svg";